// Webpack Imports
import * as bootstrap from 'bootstrap';

( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );
} )();


const currentLang = document.querySelector('html').getAttribute('lang');
const langItenEn = document.querySelector('.lang-item-en a');
const langItenRu = document.querySelector('.lang-item-ru a');
// console.log(currentLang)

if(langItenEn && currentLang == 'en-US') {
	langItenEn.addEventListener("mouseover", () => {
		langItenEn.parentElement.classList.add('text-dark');
		langItenRu.parentElement.classList.add('text-bright');
	})

	langItenEn.addEventListener("mouseout", () => {
		langItenEn.parentElement.classList.remove('text-dark');
		langItenRu.parentElement.classList.remove('text-bright');
	})

	langItenRu.addEventListener("mouseover", () => {
		langItenRu.parentElement.classList.add('text-dark');
		langItenEn.parentElement.classList.add('text-bright');
	})

	langItenRu.addEventListener("mouseout", () => {
		langItenRu.parentElement.classList.remove('text-dark');
		langItenEn.parentElement.classList.remove('text-bright');
	})
}

if(langItenRu && currentLang == 'ru-RU') {
	langItenRu.addEventListener("mouseover", () => {
		langItenRu.parentElement.classList.add('text-dark');
		langItenEn.parentElement.classList.add('text-bright');
	})

	langItenRu.addEventListener("mouseout", () => {
		langItenRu.parentElement.classList.remove('text-dark');
		langItenEn.parentElement.classList.remove('text-bright');
	})

	langItenEn.addEventListener("mouseover", () => {
		langItenEn.parentElement.classList.add('text-dark');
		langItenRu.parentElement.classList.add('text-bright');
	})

	langItenEn.addEventListener("mouseout", () => {
		langItenEn.parentElement.classList.remove('text-dark');
		langItenRu.parentElement.classList.remove('text-bright');
	})
}

const ministries = document.querySelectorAll(".ministry-container");
const introSection = document.querySelector(".intro-section__bg");
let screenHeight = screen.height;

if (introSection && introSection.getBoundingClientRect().bottom > 0 && introSection.getBoundingClientRect().bottom < (screenHeight + screenHeight * 0.1)) {
  let scale = (((screenHeight + screenHeight * 0.1) - introSection.getBoundingClientRect().bottom) / (screenHeight + screenHeight * 0.1) / 10 + 1).toFixed(2);
  introSection.style.transform = `scale(${scale})`;
}

document.addEventListener("scroll", () => {
	let screenHeight = screen.height;

  if (ministries && ministries.length > 0) {
    ministries.forEach((ministry, inx) => {
      let ministryBox = ministry.getBoundingClientRect();
      let screenHeight = window.innerHeight || document.documentElement.clientHeight;

      ministry.style.backgroundPositionY = ((ministryBox.top * 100) / screenHeight) + "%";
    });
  }

	if (introSection && introSection.getBoundingClientRect().bottom > 0 && introSection.getBoundingClientRect().bottom < (screenHeight + screenHeight * 0.1)) {
    let scale = (((screenHeight + screenHeight * 0.1) - introSection.getBoundingClientRect().bottom) / (screenHeight + screenHeight * 0.1) / 10 + 1).toFixed(2);
    introSection.style.transform = `scale(${scale})`;
	}
});


// Live Search
const form = document.getElementById("live-search-form");
if (form) {
  form.addEventListener('submit', (event) => {
    event.preventDefault();
  });
}

class Search {
  constructor() {
    this.searchInput = document.querySelector(".live-search-input");
    this.queryResults = document.querySelector(".query-results");
    this.tagButtons = document.querySelectorAll(".single-post-tag");
    this.categoryId = document.querySelector(".post-category-id");
    this.postsContainer = document.querySelector('.posts-container');
    this.backToAllBtns = document.querySelectorAll('.back-to-all-btn');
    this.htmlLang = document.documentElement.lang;
    this.events();
    this.typingLogic();
    this.isFetching = false; // Flag to keep track of ongoing request
    this.loadedIframes = 0; // Counter for loaded iframes
  }

  events() {
    this.searchInput.addEventListener('focus', () => {
      if (this.searchInput.value.trim() !== '') {
        this.queryResults.classList.add("active");
      }
    });

    this.searchInput.addEventListener('blur', () => {
      this.queryResults.classList.remove("active");
    });

    this.searchInput.addEventListener('input', () => {
      if (this.searchInput.value.trim() !== '') {
        this.typingLogic();
        this.postsContainer.classList.remove('loading');
      } else {
        this.queryResults.classList.remove("active");
      }
    });

    if (this.tagButtons) {
      this.tagButtons.forEach(tagButton => {
        tagButton.addEventListener('click', () => {
          this.postsContainer.classList.remove('default-query');
          this.postsContainer.classList.remove('loading');
          this.getResults(tagButton.getAttribute("id"));
          this.searchInput.value = "";
        })
      });
    }

    if (this.backToAllBtns) {
      this.backToAllBtns.forEach(backToAllBtn => {
        backToAllBtn.addEventListener('click', () => {
          this.postsContainer.classList.remove('loading');
          this.searchInput.value = "";
          if ( !this.postsContainer.classList.contains('default-query') ) {
            this.postsContainer.classList.add('default-query');
          }
        })
      })
    }
  }

  typingLogic() {
    clearTimeout(this.typingTimer);
    this.typingTimer = setTimeout(() => {
      if (this.searchInput.value.trim() !== '') {
        this.getResults();
        this.postsContainer.classList.remove('default-query');
      } else if ((this.searchInput.value.trim() == '')) {
        this.queryResults.classList.remove("active");
        if ( !this.postsContainer.classList.contains('default-query') ) {
          this.postsContainer.classList.add('default-query');
        }
      }
    }, 1000);
  }

  formatDate(inputDate) {
    if (!/^\d{8}$/.test(inputDate)) {
      return 'Invalid date format';
    }
    const year = inputDate.slice(0, 4);
    const month = parseInt(inputDate.slice(4, 6));
    const day = parseInt(inputDate.slice(6, 8));
    const monthNames = {
      'en-US': [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ],
      'ru-RU': [
        'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
        'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
      ]
    };
    const monthName = monthNames[this.htmlLang][month - 1];
    const formattedDate = `${day} ${monthName}, ${year}`;

    return formattedDate;
  }

  hidePreloader() {
    this.postsContainer.classList.add('loading');
  }

  getResults(tagNum) {
    // Clear existing results before adding new results
    while (this.queryResults.firstChild) {
      this.queryResults.removeChild(this.queryResults.firstChild);
    }

    // If there's an ongoing request, return without making a new request
    if (this.isFetching) {
      return;
    }

    const categoryId = this.categoryId.innerHTML;

    let postsPerPage = 12;

    if (tagNum) {
        this.url = window.location.origin + '/index.php/wp-json/wp/v2/posts?tags=' + tagNum + '&_embed' + '&per_page=' + postsPerPage;
    } else {
        this.url = window.location.origin + '/index.php/wp-json/wp/v2/posts?search=' + this.searchInput.value + '&_embed&categories=' + categoryId + '&per_page=' + postsPerPage;
    }

    // Set the isFetching flag to true before making the request
    this.isFetching = true;

    this.getJSON(this.url, data => {
      // Reset the isFetching flag once the request is completed
      this.isFetching = false;

      if (data.length === 0) {
        this.noResults = document.createElement('p');
        this.noResults.textContent = this.htmlLang === 'ru-RU' ? 'Нет результатов' : 'No results';
        this.hidePreloader();
        this.queryResults.appendChild(this.noResults);
      } else {
        let postCounter = 0;
        data.forEach(post => {
          if (postCounter >= 12) {
            return; // Break out of the loop
          }

          const postTitle = post.title.rendered;
          const postLink = post.link;
          const videoId = post.acf.youtube_video_link ? post.acf.youtube_video_link.match(/youtu\.be\/(.+)/)[1] : '';
          const heroName = post.acf.preacher_name;
          const eventDate = post.acf.sermon_date;
          const formattedDate = this.formatDate(eventDate);
          const postTemplate = this.createPostItem(postTitle, postLink, videoId, heroName, formattedDate);
          this.queryResults.appendChild(postTemplate);
          postCounter++;
        });
      }
    });
  }

  createPostItem(title, link, videoId, heroName, videoDate) {

    // Create and return the post item HTML
    const postTemplate = document.createElement('div');
    postTemplate.classList.add('query__post', 'col', 'col-md-6', 'col-xl-4');
    postTemplate.innerHTML = `
      <div class="query__post_video">
        <iframe
          class="iframe-video"
          width="100%"
          src="https://www.youtube.com/embed/${videoId}"
          title="${title}"
          frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        >
        </iframe>
      </div>
      <div class="query__post_description">
        <a href="${link}"><h2 class="query__post_title">${title}</h2></a>
        <div class="query__post_details d-flex align-items-center">
          <div class="query__post_hero-name col-6">${heroName}</div>
          <div class="query__post_date col-6">${videoDate}</div>
        </div>
      </div>
    `;

    this.hidePreloader();
    return postTemplate;
  }

  getJSON(url, callback) {
    fetch(url, {
      method: 'GET',
    })
      .then(response => response.json())
      .then(data => callback(data))
      .catch(error => console.error('Error fetching JSON:', error));
  }
}

if (document.querySelector(".live-search-input")) {
  const search = new Search();
}

// Mobile Menu

class MobileMenu {
  constructor() {
    this.body = document.querySelector("body");
    this.menuToggleBtn = document.querySelector(".menu-toggle");
    this.headerNavbar = document.querySelector(".header-navbar");

    this.menuToggleBtn.addEventListener("click", this.toggleMenu.bind(this));
    window.addEventListener("resize", this.handleResize.bind(this));
  }

  toggleMenu() {
    if (this.menuToggleBtn.classList.contains("openned") && !this.headerNavbar.classList.contains("collapsed")) {
      this.body.classList.remove("fixed");
      this.menuToggleBtn.classList.remove("openned");
      this.headerNavbar.classList.add("collapsed");
    } else {
      this.body.classList.add("fixed");
      this.menuToggleBtn.classList.add("openned");
      this.headerNavbar.classList.remove("collapsed");
    }
  }

  handleResize() {
    if (window.innerWidth >= 768) {
      this.body.classList.remove("fixed");
      this.menuToggleBtn.classList.remove("openned");
      this.headerNavbar.classList.add("collapsed");
    }
  }
}
const mobileMenu = new MobileMenu();


class ScrollToTopButton {
  constructor(element) {
    this.toTopBtn = element;
    this.init();
  }

  init() {
    window.addEventListener('scroll', () => {
      if (window.scrollY >= screen.height) {
        this.toTopBtn.style.transform = 'translateY(0)';
      } else {
        this.toTopBtn.style.transform = 'translateY(200%)';
      }
    });

    this.toTopBtn.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  }
}
const toTopBtn = document.querySelector('.to-top');
const scrollToTopButton = new ScrollToTopButton(toTopBtn);
